module.exports = __webpack_public_path__ + "img/empty.286f297f.png";